import React from "react";
import { Grid, Stack, Typography } from "@mui/material";

interface LabeledTextProps {
  label: string;
  value: string;
}

export const LabeledText: React.FC<LabeledTextProps> = ({ label, value }) => {
  return (
    <Grid item xs={12}>
      <Stack gap={1}>
        <Typography variant="inputLabel" sx={{ color: "#798397" }}>
          {label}
        </Typography>
        <Typography variant="body2">{value || "-"}</Typography>
      </Stack>
    </Grid>
  );
};

export default LabeledText;
